// extracted by mini-css-extract-plugin
export default {"resetPasswordButton":"BVbo8","formDetails":"UbYEm","formContainer":"hn54C","description":"_1hgip","blurb":"vanvN","title":"waSyx","backButton":"_6T+SG"};